import React, { FC } from "react";
import { Checkbox, Tooltip, Typography } from "antd";
import { PaymentToken } from "@dewo/app/graphql/types";
import { QuestionCircleOutlined } from "@ant-design/icons";

interface Props {
  token: PaymentToken;
  value?: boolean;
  amount?: number;
  onChange?(checked: boolean): void;
}

export const PegToUsdCheckbox: FC<Props> = ({
  token,
  value,
  amount,
  onChange,
}) => {
  const disabled = !!token && !token?.usdPrice;
  const checkbox = (
    <Checkbox
      checked={value}
      disabled={disabled}
      onChange={(e) => onChange?.(e.target.checked)}
    >
      Peg to USD
      {!disabled && (
        <Tooltip
          placement="bottom"
          title="If checked, the reward will be set in USD and converted to the equivalent amount of the selected token at the time of payment."
        >
          <QuestionCircleOutlined style={{ marginLeft: 8 }} />
        </Tooltip>
      )}
      {!!token?.usdPrice && !!value && !!amount && (
        <Typography.Text
          type="secondary"
          style={{ marginLeft: 8 }}
          className="ant-typography-caption"
        >
          (~{(amount / token.usdPrice).toFixed(3)} {token.symbol})
        </Typography.Text>
      )}
    </Checkbox>
  );

  if (!disabled) return checkbox;
  return (
    <Tooltip
      placement="bottom"
      overlayStyle={{ whiteSpace: "pre-wrap" }}
      title={
        "Dework could not find this token's USD price, so this feature is disabled. If there is a USD price for this token, write to us on Discord and we will help set this up.\n\nIf checked, the reward will be set in USD and converted to the equivalent amount of the selected token at the time of payment."
      }
    >
      {checkbox}
    </Tooltip>
  );
};
